//--- Add global TOOLS for the CMS ----
window.formHelpers = require('./src/helpers/form-helpers.js');


// WEBPACK FOOTER //
// ./ui/bundle_tools.js